module.exports = __webpack_public_path__ + "static/media/mohamed samir.f440d782.webp";